// extracted by mini-css-extract-plugin
export default {"tooltip":"E0x_Z"};